import { Font, StyleSheet } from '@react-pdf/renderer';
import { EFontWeight } from '../shared/style/enum';
import variable from '../shared/style/variable';
import RobotoBold from './font/Roboto-Bold.ttf';
import RobotoRegular from './font/Roboto-Regular.ttf';

Font.register({
    family: 'Roboto',
    fonts: [
        { src: RobotoBold, fontWeight: EFontWeight.Bold },
        { src: RobotoRegular, fontWeight: EFontWeight.Normal },
    ],
});

const styles = StyleSheet.create({
    page: {
        fontSize: 8,
        flexDirection: 'column',
        backgroundColor: variable.white,
    },
    header: {
        padding: '15 30',
    },
    footer: {
        padding: '15 30',
    },
    section: {
        padding: '5 30',
    },
    h1: {
        fontSize: 18,
        fontWeight: EFontWeight.SemiBold,
        color: variable.turquoise_500,
    },
    h2: {
        fontSize: 9,
        fontWeight: EFontWeight.SemiBold,
        color: variable.turquoise_500,
    },
    h3: {
        fontSize: 10,
        color: variable.turquoise_400,
    },
    bold: {
        fontFamily: 'Roboto',
        fontWeight: EFontWeight.Bold,
    },
    regular: {
        fontFamily: 'Roboto',
        fontWeight: EFontWeight.Normal,
    },
    tableContainer: { flexDirection: 'column', width: '100%' },
    tableHeader: { width: '100%', backgroundColor: variable.turquoise_500, color: variable.white, flexDirection: 'row' },
    tableRow: { justifyContent: 'space-between', width: '100%', flexDirection: 'row' },
    tableCell: { height: 20, flexDirection: 'column', justifyContent: 'center', flex: 1},
});

export default styles;
